/** @format */

import React, {
  useState,
  useEffect,
} from 'react';
import styles from './Main.module.scss';
import Table from '../Table/Table';
import Modal from '../Modal/Modal';
import { API_URL } from '../../../../http';
import token from '../../../../img/tokenNew.webp';
import Button from '../../../../components/Button/Button';
import SectionTitle from '../../../../components/SectionTitle/SectionTitle';
import AOS from 'aos';
import 'aos/dist/aos.css';
import FinancesTabs from '../FinancesTabs/FinancesTabs';
import getRequest from '../../../../helpers/getRequest';
import postRequest from '../../../../helpers/postRequest';
import { useTranslation } from 'react-i18next';
import PaymentTable from '../PaymentTable/PaymentTable';
import Loader from '../../../../components/Loader/Loader';
import $api from '../../../../http';
import Webcam from '../../../Dashboard/Components/Webcam/Webcam';
import { useNavigate } from 'react-router-dom';

const Main = () => {
  const [openedModal, setOpenedModal] =
    useState(false);
  const [
    isPayoutConfirmOpen,
    setIsPayoutConfirmOpen,
  ] = useState(false);
  const [profit, setProfit] = useState(null);
  const [plants, setPlants] = useState(null);
  const [pricePerGram, setPricePerGram] =
    useState(null);
  const [plantsData, setPlantsData] = useState(
    [],
  );
  const [amountWillGet, setAmountWillGet] =
    useState(0);
  const [harvestWillGet, setHarvestWillGet] =
    useState(0);
  const [clientsAmount, setClientsAmount] =
    useState(0);
  const [loading, setLoading] = useState(false);
  const [totalComission, setTotalComission] =
    useState(0);
  const [
    isSalesRegisteredUser,
    setIsSalesRegisteredUser,
  ] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getSalesPermissions = () => {
    getRequest('v1/auth/whoami')
      .then((response) => {
        const userData = response?.data || {};
        const hasSalesOwner = Boolean(
          userData.sale1_id ||
          userData.sale2_id ||
          userData.sale3_id ||
          userData.sale4_id ||
          userData.head_of_sales_id,
        );

        setIsSalesRegisteredUser(hasSalesOwner);
      })
      .catch((err) => {
        console.log(err);
        setIsSalesRegisteredUser(false);
      });
  };

  const getAmountAndGramsAvailableToGet = () => {
    setLoading(true);
    Promise.all([
      getRequest('v1/finances/data'),
      getRequest('v1/harvest/available'),
      postRequest('v1/harvest/config'),
    ])
      .then(
        ([
          financesResponse,
          availableResponse,
          configResponse,
        ]) => {
          const financesData =
            financesResponse.data;
          const availableData =
            availableResponse.data;
          const harvestBalance =
            Number(
              availableData.unsold_harvest,
            ) || 0;
          const harvestSellPrice =
            Number(
              configResponse?.data
                ?.harvestSellPrice,
            ) || 0;

          setAmountWillGet(
            harvestBalance * harvestSellPrice,
          );
          setHarvestWillGet(harvestBalance);
          setProfit(
            Number(availableData.profit) || 0,
          );
          setPlants(financesData.plants_count);
          setPricePerGram(harvestSellPrice);
          setPlantsData(
            financesData.plantsDetails,
          );
          setClientsAmount(
            financesData.nested_clients,
          );
          setLoading(false);
        },
      )
      .catch(() => {
        setLoading(false);
      });
    postRequest(
      'v1/orders/referral-orders?page=1&perPage=1000',
    )
      .then((res) => {
        setTotalComission(
          res.data.data.reduce(
            (n, { plants_count_commission }) =>
              n + +plants_count_commission,
            0,
          ),
        );
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getAmountAndGramsAvailableToGet();
    getSalesPermissions();
  }, []);

  useEffect(() => {
    AOS.init();
  }, []);

  const withdrawHarvest = () => {
    setLoading(true);
    $api({
      method: 'post',
      url: `${API_URL}/v1/harvest/withdraw`,
      headers: {
        'Content-Type': 'application/json',
        'Content-Language': localStorage
          .getItem('i18n')
          .toLowerCase(),
      },
      data: { amount: profit },
    })
      .then(() => {
        getAmountAndGramsAvailableToGet();
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  const handlePayout = () => {
    getRequest('v1/user/payment-details')
      .then((response) => {
        if (!isSalesRegisteredUser) {
          return;
        }

        const hasIban = Boolean(
          response?.data?.iban?.trim(),
        );
        const hasSwift = Boolean(
          response?.data?.bic_swift?.trim(),
        );

        if (!hasIban || !hasSwift) {
          navigate('/settings', {
            state: { fromFinancesPayout: true },
          });
          return;
        }

        setIsPayoutConfirmOpen(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const onConfirmPayout = () => {
    setIsPayoutConfirmOpen(false);
    withdrawHarvest();
  };

  const onCancelPayout = () => {
    setIsPayoutConfirmOpen(false);
  };

  return (
    <>
      {loading && <Loader />}
      <section className={styles.finances}>
        <div className={styles.finances__info}>
          <div className={styles.card}>
            {Number(plants) ? (
              <>
                <div className={styles.text}>
                  <SectionTitle
                    text={t('My tokens')}
                  />
                  <div
                    className={
                      styles.card__value
                    }>
                    {localStorage.getItem(
                      'i18n',
                    ) !== 'DE'
                      ? plants
                      : plants.replace('.', ',')}
                    <span>
                      {localStorage.getItem(
                        'i18n',
                      ) !== 'DE'
                        ? plants == 1
                          ? 'Token'
                          : 'Tokens'
                        : 'Token'}
                    </span>
                  </div>
                </div>
                <div
                  className={
                    styles.card__additional
                  }>
                  <div
                    className={
                      styles.card__myPlants_empty
                    }>
                    <Button
                      text={t('Buy Tokens')}
                      to='/buy'
                      color='green'
                    />
                  </div>
                </div>
              </>
            ) : (
              <>
                <SectionTitle
                  text={t('My Tokens')}
                />
                <div
                  className={
                    styles.card__plants_emptyText
                  }>
                  {t(
                    'You have not purchased any tokens yet.',
                  )}
                </div>
                <div
                  className={
                    styles.card__myPlants_empty
                  }>
                  <Button
                    text={t('Buy Tokens')}
                    to='/buy'
                    color='green'
                  />
                </div>
              </>
            )}
          </div>

          <div className={styles.card}>
            <div className={styles.card__info}>
              <SectionTitle
                text={t('My harvest')}
              />
              {plantsData && plantsData.length ? (
                <div
                  className={styles.card__value}>
                  {harvestWillGet}
                  <span>g</span>
                </div>
              ) : (
                <div
                  className={
                    styles.card__empty_cost
                  }>
                  0.00
                  <span>g</span>
                </div>
              )}
            </div>
            <div
              className={styles.card__additional}>
              <div
                className={
                  styles.card__additional_price
                }>
                {/* <img src={cannabis} alt="cannabis" />
                {t('Current price per gram')} */}
                {/* {plantsData && plantsData.length ? (
                  <span>{pricePerGram.toString().replace('.', ',')} €</span>
                ) : (
                  <span className={styles.card__harvest_empty}>0,00€</span>
                )} */}
              </div>
              {plantsData && plantsData.length && isSalesRegisteredUser ? (
                <Button
                  text={t('Sell Harvest')}
                  onClick={() =>
                    setOpenedModal(true)
                  }
                  color='green'
                  disabled={
                    true ||
                    harvestWillGet == 0
                      ? true
                      : false
                  }
                />
              ) : null}
            </div>
          </div>

          {/* {isSalesRegisteredUser ? (
            <div className={styles.card}>
              <div className={styles.card__info}>
                <SectionTitle
                  text={t('My result')}
                />
                {plantsData &&
                plantsData.length ? (
                  <div
                    className={
                      styles.card__value
                    }>
                    {profit}
                    <span>€</span>
                  </div>
                ) : (
                  <div
                    className={
                      styles.card__empty_cost
                    }>
                    0.00
                    <span>g</span>
                  </div>
                )}
              </div>
              <div
                className={
                  styles.card__additional
                }>
                {plantsData &&
                plantsData.length ? (
                  <div
                    className={styles.card__auto}>
                    {/* <div className={styles.card__auto_noty}>
                    <Noty />
                    <div>
                      {t('Auto-withdrawal every 15th of the following month')}
                    </div>
                  </div> //
                    <Button
                      text={t(
                        'Buy DECT with balance',
                      )}
                      color='green'
                      to='/buy?withBalance=true'
                      disabled={profit === 0}
                    />
                    <Button
                      text={t('Pay out')}
                      color='green'
                      onClick={handlePayout}
                      disabled={profit === 0}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          ) : null} */}
          <div className={styles.card}>
            <div className={styles.card__info}>
              <SectionTitle
                text={t('My referred friends')}
              />
              {clientsAmount &&
              clientsAmount != 0 ? (
                <div
                  className={styles.card__value}>
                  {clientsAmount}
                  <span>
                    {t('client')}
                    {clientsAmount == 1
                      ? ''
                      : t('s')}
                  </span>
                </div>
              ) : (
                <div
                  className={styles.card__value}>
                  0 <span>{t('clients')}</span>
                </div>
              )}
            </div>
            <div
              className={styles.card__additional}>
              <div className={styles.card__value}>
                {totalComission}
                <span>{t('tokens')}</span>
              </div>
              <div className={styles.card__auto}>
                <Button
                  text={t('Detailed statistics')}
                  color='home'
                  to='/finances/statistics'
                />
              </div>
            </div>
          </div>
        </div>
        <PaymentTable
          statuses={['PENDING']}
          title={t('Open orders')}
        />
        <PaymentTable
          statuses={[
            'PAID_OUT',
            'COMPLETED',
            'PAID',
          ]}
          title={t('Completed orders')}
        />
        <div className={styles.finances__plants}>
          {/* <h2 className={styles.finances__plants_title}>{t("My Tokens")}</h2> */}
          {plantsData && plantsData.length ? (
            <>
              <Webcam />
            </>
          ) : (
            <div
              className={styles.finances__empty}>
              <picture>
                <source
                  srcSet={token}
                  type='image/webp'
                />
                <img
                  src={token}
                  alt='empty'
                  data-aos='fade-up'
                  data-aos-duration='1000'
                />
              </picture>

              <div
                className={
                  styles.finances__empty_title
                }>
                {t(
                  'You have not purchased any tokens yet.',
                )}
              </div>
              <Button
                text={t('Buy tokens')}
                to='/buy'
                color='green'
              />
            </div>
          )}
        </div>

        <FinancesTabs />
      </section>
      {isPayoutConfirmOpen ? (
        <div className={styles.payoutModal}>
          <div
            className={styles.payoutModal__inner}>
            <h3>
              {localStorage.getItem('i18n') ===
              'DE'
                ? 'Achtung, möchten Sie das Guthaben auszahlen lassen?'
                : 'Attention: Would you like to withdraw your balance?'}
            </h3>
            <div
              className={
                styles.payoutModal__actions
              }>
              <button onClick={onConfirmPayout}>
                {localStorage.getItem('i18n') ===
                'DE'
                  ? 'Ja'
                  : 'Yes'}
              </button>
              <button onClick={onCancelPayout}>
                {localStorage.getItem('i18n') ===
                'DE'
                  ? 'Nein'
                  : 'No'}
              </button>
            </div>
          </div>
        </div>
      ) : null}
      {openedModal && (
        <Modal
          harvest={harvestWillGet}
          close={() => setOpenedModal(false)}
          pricePerGram={pricePerGram}
          amountWillGet={amountWillGet}
          harvestWillGet={harvestWillGet}
          reloadData={
            getAmountAndGramsAvailableToGet
          }
        />
      )}
    </>
  );
};

export default Main;
